import { UpsertAuthorizationEventResolutionModal } from '../UpsertAuthorizationEventResolution/UpsertAuthorizationEventResolutionModal'
import { createCreateButton } from '../../../../components/CreateButton'
import translations from '../Actions.i18n.json'

export const AuthorizationEventResolutionCreateButton = createCreateButton({
  UpsertModal: UpsertAuthorizationEventResolutionModal,
  translations,
})
